var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cell"},[_c('el-input',{ref:"elInputRef",attrs:{"size":"mini"},on:{"blur":_vm.blurFn},model:{value:(_vm.cellValue),callback:function ($$v) {_vm.cellValue=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"cellValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }